import { useMemo, type FC } from 'react';

import Grid2 from '@mui/material/Unstable_Grid2';

import TextAction from '@/components/text-action/TextAction';
import { DisplayField } from '@/components/typography/DisplayField';
import { DEFAULT_DISPLAY } from '@/constants/default-value/default-value';
import { dateUtils } from '@/utils/date';
import { t } from '@/utils/lang';

const DeviceInfo: FC<{ data: any }> = ({ data: detail }) => {
    const deviceInfo = useMemo(
        () => [
            {
                id: 1,
                title: (
                    <TextAction value={detail?.serialNumber} copy>
                        {t('Số Seri')}
                    </TextAction>
                ),
                value: detail?.serialNumber,
            },
            {
                id: 2,
                title: (
                    <TextAction
                        value={detail.rfid ? detail?.rfid : t('Chưa gắn')}
                        copy
                    >
                        {t('RFID')}
                    </TextAction>
                ),
                value: detail.rfid ? detail?.rfid : t('Chưa gắn'),
            },

            // {
            //     id: 3,
            //     title: 'Phiên bản phần mềm',
            //     value: detail?.softWareVersion,
            // },
            // {
            //     id: 4,
            //     title: (
            //         <TextAction value={detail?.contractCode} copy>
            //             {t('Mã đơn hàng ')}
            //         </TextAction>
            //     ),
            //     value: detail?.contractCode,
            // },
            {
                id: 5,
                title: (
                    <TextAction value={detail?.customer?.name} copy>
                        {t('Khách hàng')}
                    </TextAction>
                ),
                value: detail?.customer?.name,
            },
            {
                id: 14,
                title: (
                    <TextAction value={detail?.assignee?.fullname} copy>
                        {t('Kỹ thuật viên chính')}
                    </TextAction>
                ),
                value: detail?.assignee?.fullname,
            },
            {
                id: 6,
                title: (
                    <TextAction value={detail?.address} copy address>
                        {t('Địa chỉ')}
                    </TextAction>
                ),
                value: detail?.address,
            },
            {
                id: 7,
                title: (
                    <TextAction value={detail?.address} copy address>
                        {t('Vị trí lắp đặt')}
                    </TextAction>
                ),
                value: detail?.address,
            },
            {
                id: 8,
                title: (
                    <TextAction value={detail?.deviceModel?.name} copy>
                        {t('Model')}
                    </TextAction>
                ),
                value: detail?.deviceModel?.name,
            },
            {
                id: 9,
                title: (
                    <TextAction value={detail?.deviceSKU?.name} copy>
                        {t('SKU')}
                    </TextAction>
                ),
                value: detail?.deviceSKU?.name,
            },
            {
                id: 10,
                title: (
                    <TextAction value={detail?.deviceGroup?.name} copy>
                        {t('Nhóm')}
                    </TextAction>
                ),
                value: detail?.deviceGroup?.name,
            },
            {
                id: 11,
                title: (
                    <TextAction value={detail?.deviceType?.name} copy>
                        {t('Loại')}
                    </TextAction>
                ),
                value: detail?.deviceType?.name,
            },
            {
                id: 12,
                title: (
                    <TextAction value={detail?.usageType?.name} copy>
                        {t('Loại hình thức sử dụng')}
                    </TextAction>
                ),
                value: detail?.usageType?.name,
            },
            {
                id: 13,
                title: (
                    <TextAction
                        value={dateUtils.getDate(detail?.warrantyPeriod)}
                        copy
                    >
                        {t('Thời hạn bảo hành')}
                    </TextAction>
                ),
                value: dateUtils.getDate(detail?.warrantyPeriod),
            },
        ],
        [detail]
    );

    return (
        <Grid2 container spacing={5}>
            {deviceInfo.map(({ id, title, value }) => {
                return (
                    <DisplayField
                        key={id}
                        label={title ? t(title) : DEFAULT_DISPLAY}
                        value={value}
                    />
                );
            })}
        </Grid2>
    );
};

export default DeviceInfo;
